'use strict';
//import $ from 'jquery';
import BpmnApiHelper from './BpmnApiHelper';
//import qaExtension from '../resources/qa.json';
//import BpmnDebug from './BpmnDebug';
import {log} from './BpmnDebug';

import AutocompleteHelper from './AutocompleteHelper';
//import { getBusinessObject } from 'bpmn-js/lib/util/ModelUtil';
import BpmnBlocklyHelper from './BpmnBlocklyHelper';
import 'brace';
import 'brace/ext/language_tools';
import {chessNightB} from "glyphicons";

var BpmnFormHelper = {
    serviceTaskRadioValue: 'connector'
};
export default BpmnFormHelper;

BpmnFormHelper.setUpForm = function (config, moddle, modeling, bpmnFormGlobals, submitCallback) {
    var formEl = document.getElementById(config.prefix + "-form");
    formEl.addEventListener('submit', (event) => {
        log("xxxxxxxxin submit callback", config)
        event.preventDefault();
        event.stopPropagation();

        submitCallback(config, moddle, modeling, bpmnFormGlobals, event);
    });
    formEl.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            document.getElementById(config.prefix + "-container").classList.add('hidden');
        }
    });
    var cancelEl = document.getElementById(config.prefix + "-cancel");
    cancelEl.addEventListener('click', (event) => {
        log('in click listener', cancelEl, event);
        document.getElementById(config.prefix + "-container").classList.add('hidden');
    });
    // set up validation

    for (let x in config.fields) {
        log("setting up field ", x, config.fields[x]);
        config.fields[x].addEventListener('input', () => {
            var validated = validationLogic(config);
            var prefix = config.prefix;
            var warningEl = document.getElementById(prefix + "-warning");
            var submitEl = document.getElementById(prefix + "-submit");

            if (!validated) {

                warningEl.classList.remove('hidden');
                submitEl.disabled = true;
            } else {
                warningEl.classList.add('hidden');
                submitEl.disabled = false;
            }
        });
    }
};

BpmnFormHelper.LoadCommonAtts = function (config, element, businessObject, bpmnFormGlobals, event) {
    let {id, name} = businessObject;
    let nameEl = document.getElementById(config.prefix + "-name");
    let idEl = document.getElementById(config.prefix + "-id");
    let lastCheckedEl = document.getElementById(config.prefix + "-last-checked");
    nameEl.value = name ? name : '';
    idEl.value = id ? id : '';

    let analysisDetails = BpmnApiHelper.getExtensionElement(businessObject.extensionElements, 'qa:AnalysisDetails');

    lastCheckedEl.textContent = analysisDetails ? analysisDetails.lastChecked : '-';
    if (!name) {
        nameEl.focus();
    }
    nameEl.addEventListener('input', () => {
        var validated = !!nameEl.value;
        var prefix = config.prefix;
        var warningEl = document.getElementById(prefix + "-warning");
        var submitEl = document.getElementById(prefix + "-submit");

        if (!validated) {

            warningEl.classList.remove('hidden');
            submitEl.disabled = true;
        } else {
            warningEl.classList.add('hidden');
            submitEl.disabled = false;
        }
    });
};

BpmnFormHelper.CommonAttsSubmitCallback = function (config, moddle, modeling, bpmnFormGlobals, event) {
    let nameEl = document.getElementById(config.prefix + "-name");
    let name = nameEl.value;
    if (name) {
        modeling.updateProperties(config.element, {
            name: name,
        });
    }
};

BpmnFormHelper.validateName = function (config, businessObject) {
    return true;
}
BpmnFormHelper.sortFilterSrcParams = function (srcParams) {


    if (srcParams) {
        srcParams.sort(function (a, b) {
            return a.label.localeCompare(b.label);
        });
        srcParams = srcParams.filter(function (item, pos, ary) {
            return !pos || item.label !== ary[pos - 1].label;
        });
    }
    return srcParams;
}
BpmnFormHelper.convertSrcParamsToVarNames = function (srcParams) {
    let varNames = {};
    /*
     * var names 
     * { xyz : [ 'xyz','xyz.a','xyz.b]{,
     * {_errorCode: [_errorCode]}
     */
    if (srcParams) {
        srcParams.sort(function (a, b) {
            return a.label.localeCompare(b.label);
        });
        srcParams = srcParams.filter(function (item, pos, ary) {
            return !pos || item.label !== ary[pos - 1].label;
        });
        for (let i = 0; i < srcParams.length; i++) {
            let name = srcParams[i].label;
            if (name) {
                let components = name.split('.');
                if (components && components.length) {
                    let firstPart = components[0];
                    let entry = varNames[firstPart];
                    if (!entry) {
                        entry = [];

                    }
                    entry.push(name);
                    varNames[firstPart] = entry;
                }
            }
            //varNames.push(name);
        }
    }
    return varNames;
}
BpmnFormHelper.commonSetVarsAndLoadBlockly = function (config, businessObject, bpmnFormGlobals, xmlToDisplay) {
    let blocklyDiv = document.getElementById(config.prefix + '-blocklyDiv');
    BpmnFormHelper.clearHtmlElement(blocklyDiv);
    let srcParams = BpmnApiHelper.getAllSrcParams(bpmnFormGlobals.bpmnModeler);
    let varNames = BpmnFormHelper.convertSrcParamsToVarNames(srcParams);

    BpmnFormHelper.loadBlockly(blocklyDiv, varNames, businessObject, xmlToDisplay);
}
BpmnFormHelper.setServiceTaskRadioHandler = function (config, bpmnFormGlobals, moddle) {
    var el = document.getElementById('serviceTask-task-type-connector');
    if (el) {
        log("adding handler for connector");
        el.addEventListener("click", (event) => {
            BpmnFormHelper.serviceTaskRadioHandler(event, config, bpmnFormGlobals, moddle)
        })
    } else {
        log("!!!! did not find service task connector");
    }
    el = document.getElementById('serviceTask-task-type-external');
    if (el) {
        log("adding handler for external");
        el.addEventListener("click", (event) => {
            BpmnFormHelper.serviceTaskRadioHandler(event, config, bpmnFormGlobals, moddle)
        })
    } else {
        log("!!!! did not find service task external");
    }
}
BpmnFormHelper.serviceTaskRadioHandler = function (ev, config, bpmnFormGlobals, moddle) {
    log("serviceTaskRadioHandler called ", ev, ev.target.value);
    BpmnFormHelper.serviceTaskRadioValue = ev.target.value;
    BpmnFormHelper.setServiceTaskRadioChecked(BpmnFormHelper.serviceTaskRadioValue, config, bpmnFormGlobals, moddle);

}
BpmnFormHelper.setServiceTaskRadioChecked = function (str, config, bpmnFormGlobals, moddle) {
    switch (str) {
        case 'connector':
        case 'Connector':
            var el = document.getElementById('serviceTask-task-type-connector');
            if (el) {
                el.checked = true;
            }
            BpmnFormHelper.showTopicField(false, config, bpmnFormGlobals, moddle);
            break;
        case 'external':
        case 'External':
            var el = document.getElementById('serviceTask-task-type-external');
            if (el) {
                el.checked = true;
            }
            BpmnFormHelper.showTopicField(true, config, bpmnFormGlobals, moddle);
            break;

    }
}
BpmnFormHelper.showTopicField = function (show, config, bpmnFormGlobals, moddle) {

    document.getElementById('serviceTask-topic').style.display = show ? 'block' : 'none';
    document.getElementById('serviceTask-api-name').style.display = (!show) ? 'none' : 'none';
    BpmnFormHelper.ServiceTaskcbUpdateMapping(config, bpmnFormGlobals, moddle);
    //document.getElementById('serviceTask-blocklyDiv').style.display = (!show) ? 'block' : 'none';
}
BpmnFormHelper.ServiceTaskLoad = function (config, element, businessObject, bpmnFormGlobals, event) {
    config.element = element;
    //let businessObject =  getBusinessObject(element);
    config.businessObject = businessObject;
    let {api, varName, type, topic} = businessObject;
    //suitabilityScoreEl.value = suitable ? suitable : '';
    config.fieldEls.apiName.value = api ? api : '';
    config.fieldEls.varName.value = varName ? varName : '';
    BpmnFormHelper.serviceTaskRadioValue = type ? type : 'connector';
    BpmnFormHelper.setServiceTaskRadioChecked(BpmnFormHelper.serviceTaskRadioValue, config, bpmnFormGlobals, null);
    config.fieldEls.topic.value = topic ? topic : '';
    document.getElementById(config.prefix + "-container").classList.remove('hidden');
    //suitabilityScoreEl.focus();
    config.fieldEls.apiName.focus();
//    let analysisDetails = BpmnApiHelper.getExtensionElement(businessObject.extensionElements, 'qa:AnalysisDetails');
    BpmnFormHelper.ServiceTaskcbUpdateMapping(config, bpmnFormGlobals);
    BpmnFormHelper.LoadCommonAtts(config, element, businessObject, bpmnFormGlobals, event);
    //lastCheckedEl.textContent = analysisDetails ? analysisDetails.lastChecked : '-';
    //validate();
    //cbUpdateMapping(event);
    //BpmnBlocklyHelper.createWorkspace(config.prefix + '-blocklyDiv', 'toolbox'); 
    BpmnFormHelper.commonSetVarsAndLoadBlockly(config, businessObject, bpmnFormGlobals);


}

BpmnFormHelper.CustomServiceTaskLoad = function (config, element, businessObject, bpmnFormGlobals, event, apiName, varName) {
    config.element = element;
    //let businessObject =  getBusinessObject(element);
    config.businessObject = businessObject;
    // let {api, varName} = businessObject;
    //suitabilityScoreEl.value = suitable ? suitable : '';
    config.fieldEls.apiName.value = apiName;
    config.fieldEls.varName.value = varName;
    document.getElementById(config.prefix + "-container").classList.remove('hidden');
    //suitabilityScoreEl.focus();
    config.fieldEls.apiName.focus();
//    let analysisDetails = BpmnApiHelper.getExtensionElement(businessObject.extensionElements, 'qa:AnalysisDetails');
    businessObject.name = apiName;
    BpmnFormHelper.LoadCommonAtts(config, element, businessObject, bpmnFormGlobals, event);
    //lastCheckedEl.textContent = analysisDetails ? analysisDetails.lastChecked : '-';
    //validate();
    //cbUpdateMapping(event);
    //BpmnBlocklyHelper.createWorkspace(config.prefix + '-blocklyDiv', 'toolbox');
    BpmnFormHelper.commonSetVarsAndLoadBlockly(config, businessObject, bpmnFormGlobals);
    BpmnFormHelper.ServiceTaskcbUpdateMapping(config, bpmnFormGlobals);

}

BpmnFormHelper.loadBlockly = function (blocklyDiv, varNames, businessObject, xmlToDisplay) {
    let workspace = BpmnBlocklyHelper.createWorkspace(blocklyDiv, varNames);
    let extensionElements = businessObject.extensionElements;
    let analysisDetails = BpmnApiHelper.getExtensionElement(extensionElements, 'qa:AnalysisDetails');
    if (xmlToDisplay) {
        log('BpmnFormHelper.loadBlockly using input xml', xmlToDisplay)
        BpmnBlocklyHelper.loadXML(xmlToDisplay, workspace);
        return;
    }
    log("loadBlockly xml ", analysisDetails);
    if (analysisDetails) {
        let xml = analysisDetails.blockXml;
        if (xml) {
            log("loadBlockly xml is ", xml);
            BpmnBlocklyHelper.loadXML(xml, workspace);
            return;
        }
    }
    // didn't load from xml, so try json
    let jsonExtension = BpmnApiHelper.getExtensionElement(extensionElements, 'qa:APIJson');
    if (jsonExtension) {
        let json = jsonExtension.blockJson;
        if (json) {
            log("loadBlockly json is ", json);
            BpmnBlocklyHelper.loadJson(JSON.parse(json), workspace);

            return;
        }
    }
    log("loadBlockly no xml or json found");
}


BpmnFormHelper.storeQADetails = function (businessObject, moddle) {
    const extensionElements = businessObject.extensionElements || moddle.create('bpmn:ExtensionElements');
    let analysisDetails = BpmnApiHelper.getExtensionElement(extensionElements, 'qa:AnalysisDetails');
    if (!analysisDetails) {
        analysisDetails = moddle.create('qa:AnalysisDetails');
        extensionElements.get('values').push(analysisDetails);
    }
    let xml = BpmnBlocklyHelper.getXML(null);
    log("BpmnFormHelper.storeQADetails xml is ", xml, xml + '');
    analysisDetails.blockXml = xml + ''
    analysisDetails.lastChecked = new Date().toISOString();

    let jsonExtension = BpmnApiHelper.getExtensionElement(extensionElements, 'qa:APIJson');
    if (!jsonExtension) {
        jsonExtension = moddle.create('qa:APIJson');
        extensionElements.get('values').push(jsonExtension);
    }
    let json = BpmnBlocklyHelper.getJson(null, true);//just raw json
    log("BpmnFormHelper.storeQADetails json is ", json);
    jsonExtension.blockJson = json + '';
    jsonExtension.lastChecked = new Date().toISOString();

    return extensionElements;
}

BpmnFormHelper.ServiceTaskcbUpdateMapping = function (config, bpmnFormGlobals, moddle) {
    log("ServiceTaskcbUpdateMapping", config.businessObject);

    let apiList = BpmnApiHelper.apiList;
    let businessObject = config.businessObject;


    let apiName = config.fieldEls.apiName.value;
    let varName = config.fieldEls.varName.value;
    let taskType = BpmnFormHelper.serviceTaskRadioValue;
    let topic = config.fieldEls.topic.value;
    let apiDetails = BpmnApiHelper.findApiFromName(apiName, apiList);
    //let destParams = config.destParams;
    //BpmnFormHelper.saveMappingFromHtml(destParams);
    //BpmnFormHelper.saveMappingFromJson(destParams);
    // BpmnApiHelper.addApiParams(extensionElements, varName, apiDetails.apiResult, moddle, destParams);
    var json;
    switch (taskType) {
        case 'Connector':
        case 'connector':
            if (!apiDetails) {
                return;
            }
            json = BpmnApiHelper.getJsonForApiParams(varName, apiDetails.apiResult);// like above but get json structure
            break;
        case 'external':
        case 'External':
            json = {
                externalProcessName: "externalProcessName",
                externalProcessVariable: "externalProcessVariable"

            };
            break;
    }
    config.destParams = BpmnApiHelper.getAllDestParams(config.businessObject);
    let srcParams = BpmnApiHelper.getAllSrcParams(bpmnFormGlobals.bpmnModeler);
    //BpmnFormHelper.createMappingHtml(document.getElementById(config.prefix + "-mappingTable"), srcParams, config.destParams, config.businessObject);
    let varNames = BpmnFormHelper.convertSrcParamsToVarNames(srcParams);
    BpmnBlocklyHelper.createNewBlockly(document.getElementById(config.prefix + "-blocklyDiv"), varNames, config.destParams, config.businessObject, json);// load a blockly using json
}

BpmnFormHelper.ServiceTaskSubmitCallback = function (config, moddle, modeling, bpmnFormGlobals, event) {
    let apiList = BpmnApiHelper.apiList;
    let businessObject = config.businessObject;

    log("in ServiceTaskSubmitCallback", event, apiList);

    const extensionElements = BpmnFormHelper.storeQADetails(businessObject, moddle);
    let apiName = config.fieldEls.apiName.value;
    let varName = config.fieldEls.varName.value;
    let taskType = BpmnFormHelper.serviceTaskRadioValue;
    let logo = config.fieldEls.logo && config.fieldEls.logo.src ? config.fieldEls.logo.src : '';
    let topic = config.fieldEls.topic.value;

    switch (taskType) {
        case 'Connector':
        case 'connector':
            let apiDetails = BpmnApiHelper.findApiFromName(apiName, apiList);
            if (apiDetails) {
                let destParams = config.destParams;
                //BpmnFormHelper.saveMappingFromHtml(destParams);
                BpmnFormHelper.saveMappingFromJson(extensionElements, varName, apiDetails.apiResult, moddle, destParams);
                BpmnApiHelper.addApiParams(extensionElements, varName, apiDetails.apiResult, moddle, destParams);
            }
            log("updating model");
            modeling.updateProperties(config.element, {
                extensionElements,
                api: apiName,
                varName: varName,
                logo: logo
                /*,
                 suitable: suitabilityScore*/

            });
            break;
        case 'external':
        case 'External':
            BpmnFormHelper.saveMappingFromJson(extensionElements, varName, null, moddle, null);
            log("updating model");
            modeling.updateProperties(config.element, {
                extensionElements,
                api: apiName,
                varName: varName,
                topic: topic,
                type: taskType
                /*,
                 suitable: suitabilityScore*/

            });
            break;
        default:
            log("unknown task type ", taskType);
    }

    BpmnFormHelper.CommonAttsSubmitCallback(config, moddle, modeling, bpmnFormGlobals, event);
    document.getElementById(config.prefix + "-container").classList.add('hidden');


}

BpmnFormHelper.ServiceTaskAddAutocomplete = function (config, bpmnFormGlobals, moddle) {
    AutocompleteHelper.autocomplete(document.getElementById("serviceTask-api-name"), BpmnApiHelper.apiList, (event) => {
        BpmnFormHelper.ServiceTaskcbUpdateMapping(config, bpmnFormGlobals, moddle)
    });
}


BpmnFormHelper.SequenceFlowLoad = function (config, element, businessObject, bpmnFormGlobals, event) {
    config.element = element;
    config.businessObject = businessObject;
    log("SequenceFlowLoad", businessObject, config);

    document.getElementById(config.prefix + "-container").classList.remove('hidden');
    BpmnFormHelper.LoadCommonAtts(config, element, businessObject, bpmnFormGlobals, event);
    BpmnFormHelper.commonSetVarsAndLoadBlockly(config, businessObject, bpmnFormGlobals);


}


BpmnFormHelper.SequenceFlowSubmitCallback = function (config, moddle, modeling, bpmnFormGlobals, event) {
    //let apiList = bpmnFormGlobals.apiList;
    let businessObject = config.businessObject;

    log("in SequenceFlowSubmitCallback", config);

    const extensionElements = BpmnFormHelper.storeQADetails(businessObject, moddle);
    //const extensionElements = businessObject.extensionElements || moddle.create('bpmn:ExtensionElements');
    let analysisDetails = BpmnApiHelper.getExtensionElement(extensionElements, 'qa:AnalysisDetails');
    if (!analysisDetails) {
        analysisDetails = moddle.create('qa:AnalysisDetails');
        extensionElements.get('values').push(analysisDetails);
    }
    let condition = BpmnBlocklyHelper.getCode(null);

    analysisDetails.lastChecked = new Date().toISOString();


    let conditionExpression = businessObject.conditionExpression;
    log("condition expression", conditionExpression);
    if (!conditionExpression) {
        conditionExpression = moddle.create("bpmn:FormalExpression");
        businessObject.conditionExpression = conditionExpression;
    }
    conditionExpression.language = 'JavaScript';
    conditionExpression.body = condition;

    log("updating model")
    modeling.updateProperties(config.element, {
        extensionElements,
        conditionExpression: conditionExpression


    });
    BpmnFormHelper.CommonAttsSubmitCallback(config, moddle, modeling, bpmnFormGlobals, event);
    document.getElementById(config.prefix + "-container").classList.add('hidden');


}
BpmnFormHelper.removeBraces = function (condition) {
    if (!condition) {
        return '';
    }
    //strip leading ${ and }
    return condition.replace("${", "").replace("}", "");
}
BpmnFormHelper.convertConditionToComponents = function (condition) {
    log("convertConditionToComponents", condition);
    //strip leading ${ and }, and split on space (for now) TODO better splitting
    let stripCond = BpmnFormHelper.removeBraces(condition);
    log('convertConditionToComponents  strip cond', stripCond);
    let components = stripCond.split(" ");
    let result = {
        begin: '',
        select: '',
        end: ''
    };
    let len = components.length;
    if (!len) {
        result.begin = condition;
    }
    if (len) {
        result.begin = components[0];
    }
    if (len > 1) {
        result.select = components[1];
    }

    if (len > 2) {
        let sep = '';
        for (let i = 2; i < len; i++) {
            result.end = result.end + sep + components[i];
            sep = ' ';
        }
    }
    log("convertConditionToComponents condition becomes", condition, result);
    return result;
}
BpmnFormHelper.convertComponentsToCondition = function (components) {
    let result = '${';
    let sep = '';
    if (components.begin) {
        result = result + sep + components.begin;
        sep = ' ';
    }
    if (components.select) {
        result = result + sep + components.select;
        sep = ' ';
    }
    if (components.end) {
        result = result + sep + components.end;
        sep = ' ';
    }
    result = result + '}';
    log("convertComponentsToCondition components becomes", components, result);
    return result;

}


BpmnFormHelper.BoundaryEventLoad = function (config, element, businessObject, bpmnFormGlobals, event) {
    config.element = element;
    //let businessObject =  getBusinessObject(element);
    config.businessObject = businessObject;
    log("BoundaryEventLoad", businessObject, config);

    let eventDefinitions = businessObject.eventDefinitions;


    log("condition eventDefinitions", eventDefinitions);
    let condition = eventDefinitions && eventDefinitions.length ? eventDefinitions[0].condition.body : '';
    condition = BpmnFormHelper.removeBraces(condition);
    log("checking condition", condition);
    // TODO populat XML with default condition check
    let xml = '';
    if (!condition) {

        let parent = businessObject.attachedToRef;
        log("checking parent", parent);
        let {varName} = parent;
        log("varName", varName);
        if (varName) {

            xml = '<xml xmlns="https://developers.google.com/blockly/xml">\n' +
                '  <block type="' + varName + '" id="#osNK[#gvLji!I8ZqJ/9" x="8" y="10">\n' +
                '    <field name="NAME">' + varName + '.isFailed</field>\n' +
                '  </block>\n' +
                '</xml>';


        }
    }


    document.getElementById(config.prefix + "-container").classList.remove('hidden');


    BpmnFormHelper.LoadCommonAtts(config, element, businessObject, bpmnFormGlobals, event);
    BpmnFormHelper.commonSetVarsAndLoadBlockly(config, businessObject, bpmnFormGlobals, xml);


}


BpmnFormHelper.BoundaryEventSubmitCallback = function (config, moddle, modeling, bpmnFormGlobals, event) {
    //let apiList = bpmnFormGlobals.apiList;
    let businessObject = config.businessObject;

    log("in BoundaryEventSubmitCallback", config);


    const extensionElements = BpmnFormHelper.storeQADetails(businessObject, moddle);
    let analysisDetails = BpmnApiHelper.getExtensionElement(extensionElements, 'qa:AnalysisDetails');
    if (!analysisDetails) {
        analysisDetails = moddle.create('qa:AnalysisDetails');
        extensionElements.get('values').push(analysisDetails);
    }

    analysisDetails.lastChecked = new Date().toISOString();


    let eventDefinitions = businessObject.eventDefinitions;
    log("event definitions ", eventDefinitions);
    let eventDefinition = {};
    let formalExpression = {};
    if (!eventDefinitions || !eventDefinitions.length || !eventDefinitions[0].condition) {

        eventDefinition = moddle.create("bpmn:ConditionalEventDefinition");
        formalExpression = moddle.create("bpmn:FormalExpression");


    } else {
        eventDefinition = eventDefinitions[0];
        formalExpression = eventDefinition.condition;
    }

    let condition = BpmnBlocklyHelper.getCode(null);

    formalExpression.language = 'JavaScript';

    let parent = businessObject.attachedToRef;
    log("checking parent", parent);
    let {varName} = parent;
    log("varName", varName);
    if (varName) {
        formalExpression.variableName = varName;
        formalExpression.variableEvent = "update"
        formalExpression.body = BpmnApiHelper.getJSCommonDebugPart() + "\n\ntypeof " + varName + " === 'undefined' ?false :" + condition;
    } else {
        formalExpression.body = BpmnApiHelper.getJSCommonDebugPart() + "\n\n" + condition;
    }


    log("updating model ", eventDefinition, eventDefinitions)
    modeling.updateProperties(config.element, {
        extensionElements,
        eventDefinitions: eventDefinitions


    });
    BpmnFormHelper.CommonAttsSubmitCallback(config, moddle, modeling, bpmnFormGlobals, event);
    document.getElementById(config.prefix + "-container").classList.add('hidden');


};
//BpmnFormHelper.BoundaryConditionChangedEvent = function (event, moddle, modeling, bpmnModeler) {
//    log("BoundaryConditionChangedEvent called", event);
//    if (!event || !event.element || !event.element.businessObject) {
//        // not for us
//        // return;
//    } else {
//        let businessObject = event.element.businessObject;
//        if (!businessObject.$type || businessObject.$type !== "bpmn:BoundaryEvent") {
//            //not for us
//            //return;
//        } else {
//            let element = event.element;
//            let eventDefinitions = businessObject.eventDefinitions;
//            log("event definitions ", eventDefinitions);
//            let eventDefinition = {};
//            let formalExpression = {};
//            // only update if no condition
//            if (!eventDefinitions || !eventDefinitions.length || !eventDefinitions[0].condition) {
//
//                eventDefinition = moddle.create("bpmn:ConditionalEventDefinition");
//                formalExpression = moddle.create("bpmn:FormalExpression");
//
//
//
//
//                let parent = businessObject.$parent;
//                let {varName} = parent;
//                formalExpression.body = '${' + varName + '.isFailed}';
//                // let condition = conditionExpression?conditionExpression.value :'';
//
//                log("updating model ", eventDefinition, eventDefinitions)
//                modeling.updateProperties(element, {
//                    eventDefinitions: eventDefinitions
//                });
//            }
//        }
//    }
//
//
//}


BpmnFormHelper.MultiInstanceFlowLoad = function (config, element, businessObject, bpmnFormGlobals, event) {
    config.element = element;
    //let businessObject =  getBusinessObject(element);
    config.businessObject = businessObject;
    log("MultiInstance", businessObject, config);
    let loopCharacteristics = businessObject.loopCharacteristics;

    let collection = loopCharacteristics ? loopCharacteristics.collection : '';
    collection = BpmnFormHelper.removeBraces(collection);
    let variable = loopCharacteristics ? loopCharacteristics.elementVariable : '';
    log("collection variable", collection, variable);


    config.fieldEls.collection.value = collection ? collection : '';
    config.fieldEls.variable.value = variable ? variable : '';

    let srcParams = BpmnApiHelper.getAllSrcParams(bpmnFormGlobals.bpmnModeler);
    BpmnFormHelper.addSrcConditionAutocomplete(config.fieldEls.collection, srcParams);

    document.getElementById(config.prefix + "-container").classList.remove('hidden');
    //suitabilityScoreEl.focus();
    config.fieldEls.collection.focus();
    BpmnFormHelper.LoadCommonAtts(config, element, businessObject, bpmnFormGlobals, event);


}


BpmnFormHelper.MultiInstanceFlowSubmitCallback = function (config, moddle, modeling, bpmnFormGlobals, event) {
    //let apiList = bpmnFormGlobals.apiList;
    let businessObject = config.businessObject;

    log("in MultiInstanceFlowSubmitCallback", config);


    const extensionElements = BpmnFormHelper.storeQADetails(businessObject, moddle);
    let analysisDetails = BpmnApiHelper.getExtensionElement(extensionElements, 'qa:AnalysisDetails');
    if (!analysisDetails) {
        analysisDetails = moddle.create('qa:AnalysisDetails');
        extensionElements.get('values').push(analysisDetails);
    }

    analysisDetails.lastChecked = new Date().toISOString();
    let collection = config.fieldEls.collection.value;
    let variable = config.fieldEls.variable.value;

    let loopCharacteristics = businessObject.loopCharacteristics;
    if (!loopCharacteristics) {
        loopCharacteristics = moddle.create("bpmn:MultiInstanceLoopCharacteristics");
    }
    loopCharacteristics.collection = "${" + collection + "}";
    loopCharacteristics.elementVariable = variable;

//    let conditionExpression = businessObject.conditionExpression;
//    log("condition expression", conditionExpression);
//    if (!conditionExpression) {
//        conditionExpression = moddle.create("bpmn:FormalExpression");
//        businessObject.conditionExpression = conditionExpression;
//    }
//    conditionExpression.body = condition;
    // let condition = conditionExpression?conditionExpression.value :'';


    log("updating model")
    modeling.updateProperties(config.element, {
        extensionElements,
        loopCharacteristics: loopCharacteristics


    });
    BpmnFormHelper.CommonAttsSubmitCallback(config, moddle, modeling, bpmnFormGlobals, event);
    document.getElementById(config.prefix + "-container").classList.add('hidden');


}

BpmnFormHelper.ScriptTaskLoad = function (config, element, businessObject, bpmnFormGlobals, event) {
    config.element = element;
    //let businessObject =  getBusinessObject(element);
    config.businessObject = businessObject;
    log("ScriptTaskLoad", businessObject, config);
    var editor = ace.edit("scripttaskeditor");
    config.values.editor = editor;
    ace.config.set("basePath", "https://pagecdn.io/lib/ace/1.4.12/");
    var langTools = ace.require('ace/ext/language_tools');
    editor.setTheme("ace/theme/monokai");
    editor.session.setMode("ace/mode/javascript");
    let scriptCode = businessObject.script;
    if (!scriptCode) {
        scriptCode = BpmnApiHelper.getJSCommonDebugPart() + "\n// enter your script";

    }
    editor.setValue(scriptCode);
    editor.setOptions({
        enableBasicAutocompletion: true,
        enableSnippets: true,
        enableLiveAutocompletion: false
    });
    //https://stackoverflow.com/questions/30041816/ace-editor-autocomplete-custom-strings/30047705
//    var staticWordCompleter = {
//        getCompletions: function (editor, session, pos, prefix, callback) {
//            var wordList = ["foo", "bar", "baz"];
//            callback(null, [...wordList.map(function (word) {
//                    return {
//                        caption: word,
//                        value: word,
//                        meta: "static"
//                    };
//                }), ...session.$mode.$highlightRules.$keywordList.map(function (word) {
//                    return {
//                        caption: word,
//                        value: word,
//                        meta: 'keyword',
//                    };
//                })]);
//
//        }
//    }
//
//    //langTools.setCompleters([staticWordCompleter])
//// or 
//    editor.completers = [staticWordCompleter]


    let srcParams = BpmnApiHelper.getAllSrcParams(bpmnFormGlobals.bpmnModeler);
    srcParams = BpmnFormHelper.sortFilterSrcParams(srcParams);
    var completionArray = [];
    for (var i = 0; i < srcParams.length; i++) {
        completionArray.push({
                label: srcParams[i].label,
                flowName: srcParams[i].flowName
            }
        );

    }
    var jsReservedWords = [
        'debugError',
        'debugInfo',
        'debugTrace',
        'debugWarn',
        'decodeURI',
        'decodeURIComponent'
    ];

    for (var i = 0; i < jsReservedWords.length; i++) {
        completionArray.push({
                label: jsReservedWords[i],
                flowName: jsReservedWords[i]
            }
        );

    }

    var staticWordCompleter = {
        getCompletions: function (editor, session, pos, prefix, callback) {
            var wordList = completionArray;
//            callback(null, wordList.map(function (word) {
//                return {
//                    caption: word.label,
//                    value: word.label,
//                    meta: word.flowName
//                };
//            }));

            callback(null, [...wordList.map(function (word) {
                return {
                    caption: word.label,
                    value: word.label,
                    meta: word.flowName
                };
            }), ...session.$mode.$highlightRules.$keywordList.map(function (word) {
                return {
                    caption: word,
                    value: word,
                    meta: 'keyword',
                };
            })]);

        }
    }

//langTools.setCompleters([staticWordCompleter])
// or 
    editor.completers = [staticWordCompleter]
    let variable = businessObject.resultVariable;
    log("variable is ", variable);
    config.fieldEls.variable.value = variable ? variable : '';
    //BpmnFormHelper.addSrcConditionAutocomplete(config.fieldEls.collection, srcParams);
    // TODO add fields to completer
    document.getElementById(config.prefix + "-container").classList.remove('hidden');
    //suitabilityScoreEl.focus();
    //config.fieldEls.collection.focus();
    BpmnFormHelper.LoadCommonAtts(config, element, businessObject, bpmnFormGlobals, event);


}


BpmnFormHelper.ScriptTaskSubmitCallback = function (config, moddle, modeling, bpmnFormGlobals, event) {
    //let apiList = bpmnFormGlobals.apiList;
    let businessObject = config.businessObject;

    log("in ScriptTaskSubmitCallback", config);

    const extensionElements = businessObject.extensionElements || moddle.create('bpmn:ExtensionElements');

    let analysisDetails = BpmnApiHelper.getExtensionElement(extensionElements, 'qa:AnalysisDetails');
    if (!analysisDetails) {
        analysisDetails = moddle.create('qa:AnalysisDetails');
        extensionElements.get('values').push(analysisDetails);
    }


    analysisDetails.lastChecked = new Date().toISOString();

    let editor = config.values.editor;

    let condition = editor.getValue();
    let variable = config.fieldEls.variable.value;


//    let conditionExpression = businessObject.conditionExpression;
//    log("condition expression", conditionExpression);
//    if (!conditionExpression) {
//        conditionExpression = moddle.create("bpmn:FormalExpression");
//        businessObject.conditionExpression = conditionExpression;
//    }
//    conditionExpression.language = 'JavaScript';
//    conditionExpression.body = condition;

    log("updating model")
    modeling.updateProperties(config.element, {
        extensionElements,

        resultVariable: variable,
        script: condition,
        scriptFormat: "JavaScript"


    });
    BpmnFormHelper.CommonAttsSubmitCallback(config, moddle, modeling, bpmnFormGlobals, event);
    document.getElementById(config.prefix + "-container").classList.add('hidden');
}


BpmnFormHelper.cbUpdateMappingHtml = function (event) {
    log("cbUpdateMappingHtml", event);

}
BpmnFormHelper.clearHtmlElement = function (parentHtmlElement) {
    while (parentHtmlElement.firstChild) {
        parentHtmlElement.firstChild.remove();
    }
}
BpmnFormHelper.createMappingHtml = function (parentHtmlElement, srcParams, destParams, businessObject) {
    BpmnFormHelper.clearHtmlElement(parentHtmlElement);
    let autocompleteArray = [];
    let businessObjectId = businessObject.id;
    for (let i = 0; i < srcParams.length; i++) {
        let src = srcParams[i];
        let srcId = src.flowId;

        if (businessObjectId !== srcId) {
            let name = "${" + src.label + "}";
            let value = "${" + src.label + "}";
            autocompleteArray.push({
                name: name,
                value: value
            });
        }
    }
    for (let i = 0; i < destParams.length; i++) {
        let destParam = destParams[i];

        let tableRow = document.createElement("TR");
        let srcCol = document.createElement("TD");
        let srcDiv = document.createElement("DIV");
        let srcInput = document.createElement("input");
        srcInput.value = destParam.defaultValue;
        srcInput.setAttribute("id", "mappingAttr_" + i);
        srcInput.setAttribute("class", "mappingAttr-items");
        srcInput.setAttribute("autocomplete", "off");

        AutocompleteHelper.autocomplete(srcInput, autocompleteArray, BpmnFormHelper.cbUpdateMappingHtml);
        srcDiv.appendChild(srcInput);
        srcCol.appendChild(srcDiv);
        tableRow.appendChild(srcCol);

        let destCol = document.createElement("TD");
        destCol.innerHTML = destParam.id;
        tableRow.appendChild(destCol);
        parentHtmlElement.appendChild(tableRow);

    }
}

BpmnFormHelper.addSrcConditionAutocomplete = function (htmlEl, srcParams) {
    let autocompleteArray = [];

    for (let i = 0; i < srcParams.length; i++) {
        let src = srcParams[i];

        let name = src.label;
        let value = src.label;
        autocompleteArray.push({
            name: name,
            value: value
        });

    }
    AutocompleteHelper.autocomplete(htmlEl, autocompleteArray, BpmnFormHelper.cbUpdateMappingHtml);
}

BpmnFormHelper.saveMappingFromHtml = function (destParams) {
    log("saveMappingFromHtml", destParams)
    for (let i = 0; i < destParams.length; i++) {
        let destParam = destParams[i];
        let mappingId = "mappingAttr_" + i;
        let htmlElm = document.getElementById(mappingId);
        if (!htmlElm) {
            log("saveMappingFromHtml did not find ", mappingId)
            continue;
        }
        let value = htmlElm.value;
        log("saveMappingFromHtml updating ", i, value);
        destParam.value = value;


    }
}
BpmnFormHelper.saveMappingFromJson = function (extensionElements, varName, apiResult, moddle, destParams) {
    log("saveMappingFromJson");

    const jsonScriptText = BpmnBlocklyHelper.getJson(null, false)
    // need to get the business object, create a script mapping as a start script
    const jsonScript = JSON.parse(jsonScriptText);
    let script = BpmnApiHelper.addJsonMapping(jsonScript, varName, moddle);
    BpmnApiHelper.addEventListenerScript(extensionElements, 'start', script, moddle);


}

